<div [innerHTML]="widget?.text"></div>
